import { render } from "./ToggleTab.vue?vue&type=template&id=01a8d731&scoped=true"
import script from "./ToggleTab.vue?vue&type=script&lang=js"
export * from "./ToggleTab.vue?vue&type=script&lang=js"

import "./ToggleTab.vue?vue&type=style&index=0&id=01a8d731&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a8d731"]])

export default __exports__